var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"melos-tabbar-container"},_vm._l((_vm.tabs),function(tab){return _c('div',{class:{
    'selected': tab.key === _vm.activeTab,
  },on:{"click":function($event){return _vm.$emit('update:activeTab', tab.key)}}},[_vm._v("\n    "+_vm._s(tab.label)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }